const cfAlphanum = (a, b) => a?.localeCompare(b, undefined, {sensitivity: 'base', numeric: true});
const cfNumber = (a, b) => {
	if (a === b) return 0;
	if (a === null) return 1;
	if (b === null) return -1;
	return a < b ? -1 : 1;
};

export const orderInstructionInSection = (section) => ({
	...section,
	instructions: [...(section?.instructions || [])].sort(
		(a, b) =>
			cfNumber(a.auditPhaseId, b.auditPhaseId) ||
			cfNumber(a.isCustom, b.isCustom) ||
			cfNumber(a.knowledgeDisplayOrder, b.knowledgeDisplayOrder) ||
			cfAlphanum(a.instructionName, b.instructionName)
	)
});

export default (sections) => sections?.map(orderInstructionInSection);
